import { QueryClient } from "@tanstack/react-query"
import { getBusinessInformationsQuery } from "@/feature/fundraising-advisory/business-information/api/index.ts"

export const getBusinessInformationLoader =
  (queryClient: QueryClient) => async () => ({
    businessInformation: await queryClient.ensureQueryData(
      getBusinessInformationsQuery()
    ),
    businessInfoOptions: queryClient.ensureQueryData(
      getBusinessInformationsQuery()
    ),
  })
